<template>

  <v-container fluid>
   <div v-if="isPdf" id="mainContent">
        <print-invoice-Franchisee-To-BB :printData="printData"></print-invoice-Franchisee-To-BB>
      </div>
    <material-card icon="mdi-clipboard-text" inline title="Student Fee Details-Demo">
      <v-card-actions>
        <router-link :to="{ name: 'eInvoice' }">
          <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top> <v-icon left>mdi-arrow-left</v-icon>Back</v-btn>
          <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1" class="mr-n2 mt-10" style="opacity: 0.6"> <v-icon>mdi-arrow-left</v-icon></v-btn>
        </router-link>
      </v-card-actions>
      <div v-if="studentInfo">
        <v-card-component>
          <v-row key="1">
            <v-col cols="12" md="2" lg="2" xl="2" align="center">
              <v-img :src="tots_image" width="120"> </v-img>
            </v-col>
            <v-col cols="12" md="2" sm="4">
              <div class="d-flex justify-space-between caption">
                <div>
                  <div class="grey--text text-subtitle-2 mb-1">Enquiry Code</div>
                  <div class="text-button mb-1" v-text="studentInfo.enquiryCode ? studentInfo.enquiryCode : '-'"></div>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="2" sm="4">
              <div class="d-flex justify-space-between caption">
                <div>
                  <div class="grey--text text-subtitle-2 mb-1">Student Name</div>
                  <span class="text-button mb-1" v-text="studentInfo && studentInfo.studentFirstName ? studentInfo.studentFirstName + ' ' : ' '"> </span>
                  <span class="text-button mb-1" v-text="studentInfo && studentInfo.studentLastName ? studentInfo.studentLastName : ' '"> </span>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="2" sm="4">
              <div class="d-flex justify-space-between caption">
                <div>
                  <div class="grey--text text-subtitle-2 mb-1">Franchisee Name</div>
                  <div class="text-button mb-1" v-text="studentInfo && studentInfo.franchisee.companyName ? studentInfo.franchisee.companyName : '-'"></div>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="2" sm="4">
              <div class="d-flex justify-space-between caption">
                <div>
                  <div class="grey--text text-subtitle-2 mb-1">Academic Year</div>
                  <div class="text-button mb-1" v-text="studentInfo && studentInfo.academicYear.academicYear ? studentInfo.academicYear.academicYear : '-'"></div>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="2" sm="4">
              <div class="d-flex justify-space-between caption">
                <div>
                  <div class="grey--text text-subtitle-2 mb-1">Class</div>
                  <div class="text-button mb-1" v-text="studentInfo && studentInfo.class ? studentInfo.class : '-'"></div>
                </div>
              </div>
            </v-col>
          </v-row>
          <v-row key="2">
            <v-col cols="12" md="2" sm="4">
              <div class="d-flex justify-space-between caption">
                <div>
                  <div class="grey--text text-subtitle-2 mb-1">Parent / Guardian Name</div>
                  <div class="text-button mb-1" v-text="studentInfo && studentInfo.fatherName ? studentInfo.fatherName : '-'"></div>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="2" sm="4">
              <div class="d-flex justify-space-between caption">
                <div>
                  Parent / Guardian Mobile
                  <div class="grey--text text-subtitle-2 mb-1"></div>
                  <div class="text-button mb-1" v-text="studentInfo && studentInfo.fatherMobile ? studentInfo.fatherMobile : '-'"></div>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="4">
              <div class="d-flex justify-space-between caption">
                <div>
                  <div class="grey--text text-subtitle-2 mb-1">Parent / Guardian Email</div>
                  <div class="text-button mb-1" v-text="studentInfo && studentInfo.fatherEmailID ? studentInfo.fatherEmailID : '-'"></div>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="2" sm="4">
              <div class="d-flex justify-space-between caption">
                <div>
                  <div class="grey--text text-subtitle-2 mb-1">Student Gender</div>
                  <div
                    v-if="studentInfo.gender === 'Female' || studentInfo.gender === 'FEMALE'"
                    class="text-button mb-1"
                    v-text="
                      studentInfo && studentInfo.gender && studentInfo.gender === 'Female' ? 'Girl' : '-' || (studentInfo && studentInfo.gender && studentInfo.gender === 'FEMALE') ? 'Girl' : '-'
                    "
                  ></div>
                  <div
                    v-if="studentInfo.gender === 'Male' || studentInfo.gender === 'MALE'"
                    class="text-button mb-1"
                    v-text="studentInfo && studentInfo.gender && studentInfo.gender === 'Male' ? 'Boy' : '-' || (studentInfo && studentInfo.gender && studentInfo.gender === 'MALE') ? 'Boy' : '-'"
                  ></div>
                  <div v-if="studentInfo.gender === null" class="mb-1">-</div>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="2" sm="4">
              <div class="d-flex justify-space-between caption">
                <div>
                  <div class="grey--text text-subtitle-2 mb-1">Section / Division</div>
                  <div class="text-button mb-1" v-text="studentInfo.section ? studentInfo.section : '-'"></div>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card-component>
        <v-row key="3">
          <v-col cols="12">
            <template>
              <v-toolbar flat color="warning lighten-3" class="d-flex justify-center">
                <v-toolbar-title>Fee Structure (In Installments)</v-toolbar-title>
              </v-toolbar>
              <v-row>
                <v-col cols="12" lg="12" sm="12">
                  <v-data-table :headers="headers1" :items="feeTypeGroup" :single-expand="true" show-expand hide-default-footer class="elevation-1" item-key="feeTypeName">
                    <template v-slot:top>
                      <v-toolbar flat class="d-flex justify-center">
                        <v-toolbar-title>Franchisee Payments to Brainbees Paid and Due</v-toolbar-title>
                      </v-toolbar>
                    </template>
                    <template v-slot:expanded-item="{ headers, item }">
                      <td :colspan="headers.length" class="pb-4 pt-4">
                        <v-simple-table>
                          <template v-slot:default>
                            <thead>
                              <tr>
                                <th class="text-center">Installment Name</th>
                                <th class="text-center">Gross Royalty</th>
                                <th class="text-center">Discount/concession</th>
                                <th class="text-center">Gross Royalty Due(INR)</th>
                                <th class="text-center" v-if="!isIGST">Royalty CGST Amount Due(INR)</th>
                                <th class="text-center" v-if="!isIGST">Royalty SGST Amount Due(INR)</th>
                                <th class="text-center" v-if="isIGST">Royalty IGST Amount Due(INR)</th>
                                <th class="text-center">Royalty GST Amount Paid</th>
                                <th class="text-center">Royalty TDS Amount Due(INR)</th>
                                <th class="text-center">Royalty TDS Amount Paid</th>
                                <th class="text-center">Net Amount to Pay</th>
                                <th class="text-center">Actual Payment till Date</th>
                                <th class="text-center">Royalty Due Date</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="element in item.installments" :key="element.id">
                                <td align="center" justify="center">{{ element.name }}</td>
                                <td align="center" justify="center">{{ Number(element.amountRoyalty).toFixed(2) }}</td>
                                <td align="center" justify="center">{{ Number(element.amountRoyaltyConcession).toFixed(2) }}</td>
                                <td align="center" justify="center">{{ Number(element.netRoyaltyAmount).toFixed(2) }}</td>
                                <td align="center" justify="center" v-if="!isIGST">{{ Number(element.cGSTAmtRoyalty).toFixed(2) }}</td>
                                <td align="center" justify="center" v-if="!isIGST">{{ Number(element.sGSTAmtRoyalty).toFixed(2) }}</td>
                                <td align="center" justify="center" v-if="isIGST">{{ Number(element.iGSTAmtRoyalty).toFixed(2) }}</td>
                                <td align="center" justify="center">{{ Number(element.amountRoyaltyGSTPaid).toFixed(2) }}</td>
                                <td align="center" justify="center">{{ Number(element.TDSAmtRoyalty).toFixed(2) }}</td>
                                <td align="center" justify="center">{{ Number(element.amountRoyaltyTDSPaid).toFixed(2) }}</td>
                                <td align="center" justify="center">{{ Number(element.payableAmtRoyalty).toFixed(2) }}</td>
                                <td align="center" justify="center">{{ Number(element.amountRoyaltyTotalPaid).toFixed(2) }}</td>
                                <td align="center" justify="center">{{ element.dueDateRoyalty ? new Date(element.dueDateRoyalty).toLocaleDateString() : '-' }}</td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </td>
                    </template>
                    <template v-slot:body.append>
                      <tr>
                        <th class="text-center text-subtitle-2">Totals</th>
                        <th class="text-center text-subtitle-2">{{ totalAmountRoyalty.toFixed(2) }}</th>
                        <th class="text-center text-subtitle-2">{{ totalConcessionRoyalty.toFixed(2) }}</th>
                        <th class="text-center text-subtitle-2">{{ totalRoyaltynetAmount.toFixed(2) }}</th>
                        <th class="text-center text-subtitle-2" v-if="isIGST">{{ totalIGSTRoyalty.toFixed(2) }}</th>
                        <th class="text-center text-subtitle-2" v-if="!isIGST">{{ totalCGSTRoyalty.toFixed(2) }}</th>
                        <th class="text-center text-subtitle-2" v-if="!isIGST">{{ totalSGSTRoyalty.toFixed(2) }}</th>
                        <th class="text-center text-subtitle-2">{{ Number(totalGSTRoyaltyPaid).toFixed(2) }}</th>
                        <th class="text-center text-subtitle-2">{{ Number(totalTDSRoyalty).toFixed(2) }}</th>
                        <th class="text-center text-subtitle-2">{{ Number(totalTDSRoyaltyPaid).toFixed(2) }}</th>
                        <th class="text-center text-subtitle-2">{{ Number(totalAmountToPayRoyalty).toFixed(2) }}</th>
                        <th class="text-center text-subtitle-2">{{ Number(totalAmountPaidRoyalty).toFixed(2) }}</th>
                      </tr>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </template>
          </v-col>
        </v-row>
      </div>
      <v-toolbar flat class="d-flex justify-center">
        <v-toolbar-title>Franchisee Payments to Brainbees Paid</v-toolbar-title>
      </v-toolbar>
      <div v-for="(value,index) in paidInstallment" :key="index">
      <div v-if="value.length > 0">
        <v-row>
            <v-col cols="12">
                <template>
                    <v-row >
                      <v-col class="d-flex justify-end">
                        <v-btn @click="downloadInvoice(value)"> <v-icon left>mdi-printer</v-icon>Print</v-btn>
                      </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" lg="12" sm="12">
                            <v-simple-table>
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th class="text-center">Receipt No.</th>
                                            <th class="text-center">Fee Component Name</th>
                                            <th class="text-center">Installment Name</th>
                                            <th class="text-center">Discount/concession</th>
                                            <th class="text-center">Gross Royalty</th>
                                            <th class="text-center">Royalty GST Amount Paid</th>
                                            <th class="text-center">Royalty TDS Paid</th>
                                            <th class="text-center">Net Amount to Pay</th>
                                            <th class="text-center">Actual Payment till Date</th>
                                            <th class="text-center">Royalty Due Date</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="element in value" :key="element.id">
                                            <td align="center" justify="center">{{ element.paymentOrder.receiptNo}}</td>
                                            <td align="center" justify="center">{{element.assignFeeInstallment.feeTypeName}}</td>
                                            <td align="center" justify="center">{{ element.assignFeeInstallment.name }}</td>
                                            <td align="center" justify="center">{{ Number(element.assignFeeInstallment.amountRoyaltyConcession).toFixed(2) }}</td>
                                            <td align="center" justify="center">{{ Number(element.assignFeeInstallment.amountRoyalty).toFixed(2) }}</td>
                                            <td align="center" justify="center">{{ Number(element.assignFeeInstallment.amountRoyaltyGSTPaid).toFixed(2) }}</td>
                                            <td align="center" justify="center">{{ Number(element.assignFeeInstallment.amountRoyaltyTDSPaid).toFixed(2) }}</td>
                                            <td align="center" justify="center">{{ Number(element.assignFeeInstallment.amountRoyaltyTotalPaid).toFixed(2) }}</td>
                                            <td align="center" justify="center">{{ Number(element.assignFeeInstallment.amountRoyaltyTotalPaid).toFixed(2) }}</td>
                                            <td align="center" justify="center">{{ element.assignFeeInstallment.dueDateRoyalty ? new Date(element.assignFeeInstallment.dueDateRoyalty).toLocaleDateString() : '-' }}</td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-col>
                    </v-row>
                </template>
            </v-col>
        </v-row>
      </div>
      </div>
      <loading-icon :value="isLoading" />
    </material-card>
  </v-container>
</template>

<script>
import constants from '@/utils/constants'
import _ from 'lodash'
import Utils from '@/utils'
import moment from 'moment'
import MaterialCard from '../template/MaterialCard.vue'
import VCardComponent from '../template/VCardComponent.vue'
import printInvoiceFranchiseeToBB from '../Orders/History/printInvoiceFranchiseeToBB.vue'
import QRCode from 'qrcode'
export default {
  name: 'StudentRoyaltyDetails',
  components: { MaterialCard, VCardComponent, printInvoiceFranchiseeToBB },
  props: ['studentAdmissionID'],
  data () {
    return {
      isWrite: false,
      isLoading: false,
      headers: this.getHeaders(),
      headers1: this.getRoyaltyHeaders(),
      tots_image: `${constants.RAZORPAY.TOTS_IMAGE}`,
      gstType: 'IGST',
      isIGST: true,
      isGST: false,
      isConcession: false,
      loadingComponent: null,
      totalAmount: 0,
      totalAmountDue: 0,
      totalConcession: 0,
      totalAmountToPay: 0,
      totalCGST: 0,
      totalSGST: 0,
      totalIGST: 0,
      totalAmountRoyalty: 0,
      totalAmountDueRoyalty: 0,
      totalConcessionRoyalty: 0,
      totalAmountToPayRoyalty: 0,
      totalCGSTRoyalty: 0,
      totalSGSTRoyalty: 0,
      totalIGSTRoyalty: 0,
      totalTDSRoyalty: 0,
      totalTDSRoyaltyPaid: 0,
      totalGSTRoyaltyPaid: 0,
      totalnetAmount: 0,
      feeActiveComponent: {},
      refundRemark: '',
      feeTypeGroup: [],
      studentInfo: null,
      totalamountDueTillDate: 0,
      totalamountNonDueTillDate: 0,
      refundRemarkLogs: [],
      pasteEvent: null,
      pasteEventHandler: null,
      paidInstallment: [],
      isPdf: false,
      printableData: {},
      paymentOrder: [],
      invoiceDetails: null,
      printData: {
        studentInfo: null,
        paymentOrder: null,
        eInvoiceDetails: null,
        qrCodeUrl: null
      }
    }
  },
  async created () {
    await this.getAllInfo()
    this.isWrite = Utils.helper.getIsWriteFun(this.$route)
  },
  methods: {
    getPaymentDetails: async function () {
      try {
        let response = await http.post(`${constants.API_URL}/api/students/get-payment-history`,
          {
            franchiseeID: this.studentInfo.franchisee.id,
            academicYearID: this.studentInfo.academicYearID,
            classID: this.studentInfo.studentClass.id,
            enquiryID: this.studentInfo.id
          })
        this.paidInstallment = response.data
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message

        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } finally {
        this.loadingComponent.close()
      }
    },
    downloadInvoice: async function (paymentOrder) {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        await this.getInvoiceDetails(paymentOrder)
        this.isPdf = true
        this.printData.paymentOrder = paymentOrder
        this.printableData = this.printData
        this.$nextTick(() => {
          this.printInvoice('printableArea')
        })
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.loadingComponent.close()
      }
    },
    printInvoice: async function (content) {
      // Get HTML to print from element
      this.prtHtml = document.getElementById(content).innerHTML

      // Get all stylesheets HTML
      let stylesHtml = ''
      for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
        stylesHtml += node.outerHTML
      }

      // Open the print window
      const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=1300,toolbar=0,scrollbars=0,status=0')

      WinPrint.document.write(`<!DOCTYPE html>
      <html>
      <head>
      ${stylesHtml}
      </head>
      <body>
      ${this.prtHtml}
      </body>
      <style>

      @media print {
      .page-break {
      height: 0;
      page-break-before: always;
      margin: 0;
      border-top: none;
      }
      }

      body, p{
      font-size: 9pt;
      font-family: Arial, Helvetica, sans-serif;
      }

      body {
      margin-left: 2em;
      margin-right: 2em;
      padding-left: 2em;
      }

      .card{
      padding-left: 2em;
      }

      .page {
      height: 1300px;
      padding-top: 5px;
      page-break-after: always;
      font-family: Arial, Helvetica, sans-serif;
      position: relative;
      border-bottom: 1px solid #000;
      }
      </style>
      </html>`)

      WinPrint.document.close()

      WinPrint.focus()

      setTimeout(function () {
        WinPrint.print()
      }, 500)

      this.resetResult()
    },
    getInvoiceDetails: async function (paymentOrder) {
      try {
        let response = await http.post(`${constants.API_URL}/api/students/get-invoice-details`, { paymentOrderID: paymentOrder[0].paymentOrder.paymentID, enquiryCode: this.studentInfo.enquiryCode })
        this.invoiceDetails = response
        this.printData.eInvoiceDetails = this.invoiceDetails
        this.printData.studentInfo = this.invoiceDetails.data.studentDetails
        try {
          let opts = {
            errorCorrectionLevel: 'H',
            type: 'image/jpeg',
            quality: 1,
            margin: 3,
            color: {
              dark: '#000000 ',
              light: '#FFFFFF'
            },
            width: 450
          }
          if (this.invoiceDetails.data.eInvoiceDetails) {
            let QRCodeString = `${this.invoiceDetails.data.eInvoiceDetails.qrCode}.toString('base64')}`
            this.printData.qrCodeUrl = await QRCode.toDataURL(QRCodeString, opts)
          } else {
            this.printData.qrCodeUrl = null
          }
        } catch (e) {
          console.log(e)
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message

        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },

    resetResult () {
      this.printableData = {}
      this.isPdf = false
    },

    getRoyaltyHeaders () {
      let royaltyHeader = [{ text: 'Fee Type', value: 'feeTypeName', align: 'center' }]
      royaltyHeader.push({ text: 'Gross Royalty (INR)', value: 'totalAmountRoyalty', align: 'center' })

      royaltyHeader.push({ text: 'Discount/Concession(INR)', value: 'totalConcessionRoyalty', align: 'center' })

      royaltyHeader.push({ text: 'Gross Royalty Due (INR)', value: 'totalRoyaltynetAmount', align: 'center' })
      if (this.isIGST) {
        royaltyHeader.push({ text: 'Royalty IGST Due (INR)', value: 'totalIGSTRoyalty', align: 'center' })
      } else {
        royaltyHeader.push({ text: 'Royalty CGST Due (INR)', value: 'totalCGSTRoyalty', align: 'center' })
        royaltyHeader.push({ text: 'Royalty SGST Due (INR)', value: 'totalSGSTRoyalty', align: 'center' })
      }
      royaltyHeader.push({ text: 'Royalty GST Paid (INR)', value: 'totalRoyaltyGSTPaid', align: 'center' })
      royaltyHeader.push({ text: 'Royalty TDS Due (INR)', value: 'totalTDSAmtRoyalty', align: 'center' })
      royaltyHeader.push({ text: 'Royalty TDS Paid (INR)', value: 'totalRoyaltyTDSPaid', align: 'center' })
      royaltyHeader.push({ text: 'Net Amount to Pay (INR)', value: 'totalAmountPayableRoyalty', align: 'center' })
      royaltyHeader.push({ text: 'Actual Payment Till Date (INR)', value: 'totalAmountTotalPaidRoyalty', align: 'center' })

      royaltyHeader.push({ text: '', value: 'data-table-expand' })
      return royaltyHeader
    },
    getHeaders () {
      let header = [
        { text: 'Fee Type', value: 'feeTypeName', align: 'center' },
        { text: 'Gross Amount (INR)', value: 'totalAmount', align: 'center' }
      ]
      header.push({ text: ' Concession Remark', value: 'concessionRemark', align: 'center' })
      header.push({ text: 'Less : Concession (INR)', value: 'totalConcession', align: 'center' })
      header.push({ text: 'Net Amount(INR)', value: 'totalnetAmount', align: 'center' })

      if (this.isGST) {
        if (this.isIGST) {
          header.push({ text: 'IGST (INR)', value: 'totalIGST', align: 'center' })
        } else {
          header.push({ text: 'CGST (INR)', value: 'totalCGST', align: 'center' })
          header.push({ text: 'SGST (INR)', value: 'totalSGST', align: 'center' })
        }
      }

      header.push({ text: 'Amount Paid till Date(INR)', value: 'totalAmountPaid', align: 'center' })

      header.push({ text: 'Net Amount Due(INR)', value: 'totalamountNonDueTillDate', align: 'center' })
      header.push({ text: 'Net Amount not Due(INR)', value: 'totalamountDueTillDate', align: 'center' })

      header.push({ text: '', value: 'data-table-expand' })
      return header
    },
    getAllInfo: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        let response = await http.get(`${constants.API_URL}/api/admission-fee-details/${this.studentAdmissionID}`)
        this.studentInfo = response.data.studentInfo
        this.printData.studentInfo = this.studentInfo
        this.getPaymentDetails()
        this.studentInfo.studentFirstName = this.studentInfo.studentFirstName ? this.studentInfo.studentFirstName : ''
        this.studentInfo.studentLastName = this.studentInfo.studentLastName ? this.studentInfo.studentLastName : ''
        this.feeActiveComponent = response.data
        const feeTypeData = response.data.feeTypes
        this.feeTypeGroup = feeTypeData.feeTypeGroup
        this.isConcession = feeTypeData.isConcession
        this.gstType = feeTypeData.gstType
        this.isIGST = _.isEqual(feeTypeData.gstType, 'IGST')
        this.isGST = feeTypeData.isGST
        this.totalAmount = 0
        this.totalAmountDue = 0
        this.totalConcession = 0
        this.totalAmountToPay = 0
        this.totalAmountToPaid = 0
        this.totalIGST = 0
        this.totalCGST = 0
        this.totalSGST = 0
        this.totalAmountRoyalty = 0
        this.totalAmountDueRoyalty = 0
        this.totalConcessionRoyalty = 0
        this.totalAmountToPayRoyalty = 0
        this.totalAmountPaidRoyalty = 0
        this.totalOtherCollection = 0
        this.totalIGSTRoyalty = 0
        this.totalCGSTRoyalty = 0
        this.totalSGSTRoyalty = 0
        this.totalTDSRoyalty = 0
        this.totalTDSRoyaltyPaid = 0
        this.totalGSTRoyaltyPaid = 0
        this.totalnetAmount = 0
        this.totalRoyaltynetAmount = 0
        this.totalamountDueTillDate = 0
        this.totalamountNonDueTillDate = 0
        _.forEach(this.feeTypeGroup, (item) => {
          item.totalamountDueTillDate = 0
          item.totalamountNonDueTillDate = 0
        })
        _.forEach(this.feeTypeGroup, (item) => {
          _.forEach(item.installments, (obj) => {
            obj.refundRemarkLogs = _.orderBy(obj.refundRemarkLogs, ['updatedAt'], ['desc'])
            obj.refundRemarkLogs = obj.refundRemarkLogs.map((a) => {
              a.updatedAt = moment(a.updatedAt).format('YYYY-MM-DD')
              return a
            })
            obj.netAmount = this.subTwoNumber(obj.amount, obj.amountConcession)
            obj.netRoyaltyAmount = this.subTwoNumber(obj.amountRoyalty, obj.amountRoyaltyConcession)

            if (moment(obj.dueDate).format('YYYY-MM-DD') <= moment().format('YYYY-MM-DD')) {
              obj.amountDueTillDate = 0
            } else {
              obj.amountDueTillDate = obj.amountDue
            }
            if (moment(obj.dueDate).format('YYYY-MM-DD') > moment().format('YYYY-MM-DD')) {
              obj.amountNonDueTillDate = 0
            } else {
              obj.amountNonDueTillDate = obj.amountDue
            }
            item.totalamountDueTillDate = this.addTwoNumber(Number(obj.amountDueTillDate), Number(item.totalamountDueTillDate))
            item.totalamountNonDueTillDate = this.addTwoNumber(Number(obj.amountNonDueTillDate), Number(item.totalamountNonDueTillDate))
            obj.amountDue = parseInt(obj.amountDue)
            obj.amountConcession = parseInt(obj.amountConcession)
            if (obj.amountDue <= 0) {
              obj.showConcessionBtn = obj.amountConcession > 0
            } else if (obj.amountDue > 0) {
              obj.showConcessionBtn = true
            }
          })
          this.totalAmount = this.addTwoNumber(item.totalAmount, this.totalAmount)
          this.totalAmountDue = this.addTwoNumber(item.totalAmountDue, this.totalAmountDue)
          this.totalConcession = this.addTwoNumber(item.totalConcession, this.totalConcession)
          this.totalIGST = this.addTwoNumber(item.totalIGST, this.totalIGST)
          this.totalCGST = this.addTwoNumber(item.totalCGST, this.totalCGST)
          this.totalSGST = this.addTwoNumber(item.totalSGST, this.totalSGST)
          this.totalAmountToPay = this.addTwoNumber(item.totalAmountPayable, this.totalAmountToPay)
          this.totalAmountToPaid = this.addTwoNumber(item.totalAmountPaid, this.totalAmountToPaid)
          this.totalAmountRoyalty = this.addTwoNumber(item.totalAmountRoyalty, this.totalAmountRoyalty)
          this.totalAmountDueRoyalty = this.addTwoNumber(item.totalAmountDueRoyalty, this.totalAmountDueRoyalty)
          this.totalConcessionRoyalty = this.addTwoNumber(item.totalConcessionRoyalty, this.totalConcessionRoyalty)
          this.totalIGSTRoyalty = this.addTwoNumber(item.totalIGSTRoyalty, this.totalIGSTRoyalty)
          this.totalCGSTRoyalty = this.addTwoNumber(item.totalCGSTRoyalty, this.totalCGSTRoyalty)
          this.totalSGSTRoyalty = this.addTwoNumber(item.totalSGSTRoyalty, this.totalSGSTRoyalty)
          this.totalTDSRoyalty = this.addTwoNumber(item.totalTDSAmtRoyalty, this.totalTDSRoyalty)
          this.totalTDSRoyaltyPaid = this.addTwoNumber(item.totalRoyaltyTDSPaid, this.totalTDSRoyaltyPaid)
          this.totalGSTRoyaltyPaid = this.addTwoNumber(item.totalRoyaltyGSTPaid, this.totalGSTRoyaltyPaid)

          this.totalAmountToPayRoyalty = this.addTwoNumber(item.totalAmountPayableRoyalty, this.totalAmountToPayRoyalty)
          this.totalAmountPaidRoyalty = this.addTwoNumber(item.totalAmountTotalPaidRoyalty, this.totalAmountPaidRoyalty)
          this.totalOtherCollection = this.addTwoNumber(item.totalOtherCollection, this.totalOtherCollection)

          item.totalnetAmount = this.subTwoNumber(item.totalAmount, item.totalConcession)
          this.totalnetAmount = this.addTwoNumber(item.totalnetAmount, this.totalnetAmount)

          item.totalRoyaltynetAmount = this.subTwoNumber(item.totalAmountRoyalty, item.totalConcessionRoyalty)
          this.totalRoyaltynetAmount = this.addTwoNumber(item.totalRoyaltynetAmount, this.totalRoyaltynetAmount)

          this.totalamountDueTillDate = this.addTwoNumber(item.totalamountDueTillDate, this.totalamountDueTillDate)

          this.totalamountNonDueTillDate = this.addTwoNumber(item.totalamountNonDueTillDate, this.totalamountNonDueTillDate)
        })

        this.headers = this.getHeaders()
        this.headers1 = this.getRoyaltyHeaders()
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message

        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } finally {
        this.loadingComponent.close()
      }
    },
    addTwoNumber (num1, num2) {
      return this.toFixed(Number(num1) + Number(num2))
    },

    subTwoNumber (num1, num2) {
      return this.toFixed(Number(num1) - Number(num2))
    },
    toFixed (number, length = 2) {
      return Number(Number(number).toFixed(length))
    }
  }
}
</script>
<style scoped>
.number-input >>> input[type='number'] {
  -moz-appearance: textfield;
}
.number-input >>> input::-webkit-outer-spin-button,
.number-input >>> input::-webkit-inner-spin-button {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}
@media print {
  #mainContent {
    position: absolute;
    width: 100%;
    min-height: 100vh;
    top: 0;
    left: 0;
  }
}
</style>
